
export enum uploadOptions {Waiting, Failed, Success, PDFExpected, ShapeExpected, JPGExpected};

export enum enumUploadStatus {
    Ready = 0,
    FieldsRequired = 1,
    SelectFile = 2,
    FileTooLarge = 3,
    WrongFileType = 4
}
